import AppService from './AppService';

const AgentService = {
  chat: (sessionId, message) =>
    AppService.post('/v1/agent/chat', { sessionId, message }),

  getConfig: () =>
    AppService.get('/v1/agent/config'),

  getHistory: (sessionId) =>
    AppService.get(`/v1/agent/history/${sessionId}`),

  // Reset usage for an org (extends daily limit)
  resetUsage: (orgId) =>
    AppService.post(`/v1/agent/admin/reset-usage/${orgId}`),

  // Admin endpoints
  listOrganizations: () =>
    AppService.get('/v1/agent/admin/organizations'),

  getOrgConfig: (orgId) =>
    AppService.get(`/v1/agent/admin/config/${orgId}`),

  updateOrgConfig: (orgId, config) =>
    AppService.put(`/v1/agent/admin/config/${orgId}`, config),

  getUsage: (days = 30) =>
    AppService.get(`/v1/agent/admin/usage?days=${days}`),

  getDailyUsage: (orgId, days = 30) =>
    AppService.get(`/v1/agent/admin/usage/${orgId}?days=${days}`),
};

export default AgentService;
